import { sessionStorageUtil } from '@/core/services/storage/utils/sessionStorageUtil';
import type { ImageSearchEmbeddingResponse } from '../constants';

export const IMAGE_SEARCH_STORAGE_KEY = 'designsForImageSearch';

function toDesignIdStrings(items: unknown[]): string[] {
  return items
    .map((item) => {
      if (typeof item === 'object' && item != null) {
        const record = item as Record<string, unknown>;
        if ('id' in record) return String(record.id);
        if ('designId' in record) return String(record.designId);
      }
      return String(item);
    })
    .map((id) => id.trim())
    .filter(Boolean);
}

/** Embedding API response → design ID strings for sessionStorage and batch/design POST. */
export function normalizeImageSearchEmbeddingResult(result: ImageSearchEmbeddingResponse): string[] {
  return result.map((id) => String(id).trim()).filter(Boolean);
}

export function readImageSearchPayloadFromSessionStorage(
  key: string = IMAGE_SEARCH_STORAGE_KEY,
): string[] {
  const raw = sessionStorageUtil.getItem<unknown>(key);
  if (!Array.isArray(raw)) return [];
  return toDesignIdStrings(raw);
}

export function writeImageSearchPayloadToSessionStorage(designIds: string[]): void {
  sessionStorageUtil.setItem(IMAGE_SEARCH_STORAGE_KEY, designIds);
}

/** Listing cache key when image search payload or navigation changes. */
export function getImageSearchListingKeySuffix(
  designIds: string[],
  navigationTs: number | null,
): string {
  if (designIds.length === 0) {
    return navigationTs != null ? `empty-${navigationTs}` : 'empty';
  }
  return `${designIds.length}-${designIds[0]}-${navigationTs ?? ''}`;
}
